import { type AvailabilityCondition, AvailabilityEnum } from '../types';

export interface GetCareOrderMarketsConditionParams {
  careOrderMarkets: string[] | undefined;
}

const CONDITION_ID = 'care-order-markets-condition';

/** A condition just checking if the item's Market.Name is in some array of market names.
 * Can be generalized to not be called CareOrders-- but can do that at a later point
 */
export function getCareOrderMarketsCondition({
  careOrderMarkets,
}: GetCareOrderMarketsConditionParams): AvailabilityCondition {
  if (!careOrderMarkets || careOrderMarkets.length === 0) {
    return {
      id: CONDITION_ID,
      condition: () => ({ availability: AvailabilityEnum.Ok }),
      ready: true,
    };
  }

  const marketsSet = new Set(careOrderMarkets);
  return {
    id: CONDITION_ID,
    condition: market => {
      return marketsSet.has(market.Name)
        ? { availability: AvailabilityEnum.Ok }
        : {
            availability: AvailabilityEnum.NotAllowed,
            infoNode: "Market not included in Care Order's approved markets list",
          };
    },
    ready: true,
  };
}
